import { Link, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton, Tab, Tabs, Typography } from '@mui/material';
import Component from '../../components/Component';
import DailyTasksCalendarPage from './DailyTasksCalendarPage';
import DailyTasksDayPage from './DailyTasksDayPage';
import WheelSettingsPage from './WheelSettingsPage';
import BonusMilestonesPage from './BonusMilestonesPage';
import DailiesFlagsPanel from './DailiesFlagsPanel';

function dailyTasksTab(pathname) {
  if (pathname.includes('/wheel')) return 'wheel';
  if (pathname.includes('/milestones')) return 'milestones';
  if (pathname.includes('/flags')) return 'flags';
  if (/\/day\//.test(pathname) || /\/\d{4}-\d{2}-\d{2}/.test(pathname)) return 'calendar';
  return 'calendar';
}

function DailyTasks() {
  const location = useLocation();
  const tabValue = dailyTasksTab(location.pathname);
  const onDayEditor = /\/(day\/)?\d{4}-\d{2}-\d{2}/.test(location.pathname);

  return (
    <Component>
      <div
        className="daily-tasks-container"
        style={{
          marginLeft: '280px',
          marginTop: '80px',
          padding: '20px',
          width: 'calc(100% - 280px)',
        }}
      >
        <div className="d-flex align-items-center mb-2">
          <IconButton style={{ background: '#FFFFFF' }} component={Link} to="/">
            <ArrowBackIcon />
          </IconButton>
          <div style={{ marginLeft: '12px' }}>
            <h2 style={{ margin: 0 }}>Daily Tasks</h2>
            <Typography variant="body2" color="text.secondary">
              Schedule and publish each IST day of the Daily Tasks page — missions, challenges,
              opinions, rewards, wheel, and milestones. Mission pack editing stays on{' '}
              <Link to="/admin/daily-missions?from=today">Daily Missions</Link>.
            </Typography>
          </div>
        </div>

        {!onDayEditor && (
          <Tabs value={tabValue} sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
            <Tab label="Calendar" value="calendar" component={Link} to="/admin/daily-tasks" />
            <Tab label="Wheel" value="wheel" component={Link} to="/admin/daily-tasks/wheel" />
            <Tab
              label="Bonus milestones"
              value="milestones"
              component={Link}
              to="/admin/daily-tasks/milestones"
            />
            <Tab
              label="Feature flags"
              value="flags"
              component={Link}
              to="/admin/daily-tasks/flags"
            />
          </Tabs>
        )}

        <Routes>
          <Route index element={<DailyTasksCalendarPage />} />
          <Route path="wheel" element={<WheelSettingsPage />} />
          <Route path="milestones" element={<BonusMilestonesPage />} />
          <Route path="flags" element={<DailiesFlagsPanel />} />
          <Route path="day/:date" element={<DailyTasksDayPage />} />
          <Route path=":date" element={<DailyTasksDayPage />} />
          <Route path="*" element={<Navigate to="/admin/daily-tasks" replace />} />
        </Routes>
      </div>
    </Component>
  );
}

export default DailyTasks;
